export * from "./uicomponents/uicomponents.module";
export * from "./core/core.module";
export * from "./shared/shared.module";
export * from "./course-management/course-management.module";
export * from "./cre-tracking/cre-management.module";
export * from "./student/student.module";
